import React from "react";
import { FaCircleUser } from "react-icons/fa6";
import web from "../assets/images/web.gif";
import Navbar from "../components/body_nav";
import { Link } from "react-router-dom";

function body() {
  const blog_data = [
    {
      img: web,
      name: "Want To Upgrade Your Brain?",
      category: "Application",
      date: "November 14, 2024",
      slug: "Blog$#",
    },
    {
      img: web,
      name: "Want To Upgrade Your Brain?",
      category: "Application",
      date: "November 14, 2024",
      slug: "Blog$#",
    },
    {
      img: web,
      name: "Want To Upgrade Your Brain?",
      category: "Application",
      date: "November 14, 2024",
      slug: "Blog$#",
    },
    {
      img: web,
      name: "Want To Upgrade Your Brain?",
      category: "Application",
      date: "November 14, 2024",
      slug: "Blog$#",
    },
    {
      img: web,
      name: "Want To Upgrade Your Brain?",
      category: "Application",
      date: "November 14, 2024",
      slug: "Blog$#",
    },
    {
      img: web,
      name: "Want To Upgrade Your Brain?",
      category: "Application",
      date: "November 14, 2024",
      slug: "Blog$#",
    },
  ];
  return (
    <>
      <Navbar title={"Blogs"} icon={<FaCircleUser />} />

      <div class="pt-3 pb-2 w-[95%]">
        <p class="text-lightgrey">
          Welcome to my blog, where I share insights, tutorials, and updates on
          the latest trends in technology and development. Here, you'll find a
          variety of articles ranging from in-depth guides on React and Django
          to tips on optimizing web performance and managing databases. My goal
          is to provide valuable content that helps fellow developers enhance
          their skills and stay informed about industry advancements. Dive in to
          explore my thoughts and experiences, and feel free to join the
          conversation by leaving your comments and feedback.
        </p>
      </div>

      <div className="flex justify-center text-seagreen text-lg mt-6">Blogs under creation...</div>
      {/* <div className="flex gap-[2.5%] w-[100%] flex-wrap overflow-y-auto pl-1 mb-4 mt-2">
        {blog_data.map((item, index) => (
          <div className="flex flex-col gap-1 justify-center h-fit w-[100vw] py-2 rounded-md md:w-[31%]">
            <div className="relative  rounded-2xl bg-lightgrey">
              <img
                src={item.img}
                alt="skill"
                class=" rounded-xl hover:scale-105"
              />
              <p className="absolute bottom-2 left-2 bg-secondary rounded px-2 text-lightgrey ">
                {item.category}
              </p>
            </div>
            <Link
              to={item.slug}
              className="text-lightgrey text-xl font-semibold hover:text-seagreen"
            >
              {item.name}
            </Link>
            <h4 className="text-darkgrey">{item.date}</h4>
          </div>
        ))}
      </div> */}
    </>
  );
}

export default body;
